import { IconButton, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { NavbarDrawer } from '../../NavbarDrawer'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconButton: {
      marginLeft: theme.spacing(2),
    },
  })
)

export const MenuIconButton = () => {
  const classes = useStyles()

  return (
    <NavbarDrawer>
      {openDrawer => (
        <IconButton
          onClick={openDrawer}
          edge="start"
          className={classes.iconButton}
          color="inherit"
          size="large">
          <MenuIcon />
        </IconButton>
      )}
    </NavbarDrawer>
  );
}
